module.exports = __webpack_public_path__ + "img/software.a33b6c41.png";